
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 24H5a1.5 1.5 0 01-1.5-1.5v-21A1.5 1.5 0 015 0h7a1.5 1.5 0 01.9.3l7 5a1.5 1.5 0 01.6 1.2v16A1.5 1.5 0 0119 24zM5 1a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-16A.5.5 0 0019 6h-5a1.5 1.5 0 01-1.5-1.5v-3A.5.5 0 0012 1zm8.5 1v2.5a.5.5 0 00.5.5h3.8z"}}),_c('path',{attrs:{"d":"M17 10H7a.5.5 0 010-1h10a.5.5 0 010 1zm0 4H7a.5.5 0 010-1h10a.5.5 0 010 1zm0 4H7a.5.5 0 010-1h10a.5.5 0 010 1z"}})])
          )
        }
      }
    